// Modules
import React from "react";

// Styles
import "./CheckAvailabilityError.sass";

type Props = {
  message: JSX.Element[],
}

class CheckAvailabilityError extends React.Component<Props, {}> {
  render() {
    const {message} = this.props;

    return (
      <section className="check-availability-error">
        <i className="fa fa-exclamation-triangle"></i>
        <p aria-live="polite">{message}</p>
      </section>
    );
  }
}

export {
  CheckAvailabilityError,
};
